var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddCircle1X(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icons /large/ add_circle@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.016,12.984 L17.016,11.015 L12.985,11.015 L12.985,6.984 L11.016,6.984 L11.016,11.015 L6.985,11.015 L6.985,12.984 L11.016,12.984 L11.016,17.015 L12.985,17.015 L12.985,12.984 L17.016,12.984 Z M12,2.016 C17.531,2.016 21.984,6.469 21.984,12 C21.984,17.531 17.531,21.984 12,21.984 C6.469,21.984 2.016,17.531 2.016,12 C2.016,6.469 6.469,2.016 12,2.016 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Module-/-Expand-/-PS-View-/-Entire-Project-Info",
    transform: "translate(-66.000000, -96.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Add-Delivery-Restriction",
    transform: "translate(40.000000, 80.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(24.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "add_circle",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)",
    fill: "#0A649D",
    id: "\\uD83C\\uDFA8-color"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24.2424242,
    height: 24.2424242
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCircle1X);
export default __webpack_public_path__ + "static/media/add_circle@1x.adf0dbaf8fa75261600af8e65658bd36.svg";
export { ForwardRef as ReactComponent };